angular.module('mercury.modules.cashup', [
  'mercury.modules.cashup.edit',
  'mercury.modules.cashup.overview'
]);
